import { z } from 'zod';
import { RoleSchema } from './common';

/** Public projection of a User — safe to return from the API. Never includes emergencyContact. */
export const UserPublicSchema = z.object({
  id: z.string().cuid(),
  role: RoleSchema,
  pseudonym: z.string().nullable(),
  displayName: z.string().nullable(),
  isAnonymous: z.boolean(),
  createdAt: z.string().datetime(),
});
export type UserPublic = z.infer<typeof UserPublicSchema>;

/**
 * Emergency contact — plaintext shape used ONLY at the boundary
 * (client input, therapist reveal). At rest it lives encrypted (AES-256-GCM).
 */
export const EmergencyContactSchema = z.object({
  name: z.string().min(1).max(120),
  phone: z.string().min(4).max(30),
  address: z.string().max(240).optional(),
  relation: z.string().max(60).optional(),
});
export type EmergencyContact = z.infer<typeof EmergencyContactSchema>;
